import React,{useRef} from "react";
import "./RejectedMilkViewer.css";
import StampIcon from "../assets/icons/Stamp.svg";
import CalendarIcon from "../assets/icons/calendar.svg";

const formatDisplayDate = (date) =>
  date ? date.split("-").reverse().join("-") : "";

const RejectedMilkViewer = ({
  data,
  isLoading = false,
  selectedDate,
  onDateChange,
  maxDate,
}) => {
  const rejectedMilkData = data?.data || [];
  const dateInputRef = useRef(null);
  const hasRejectedMilkData = rejectedMilkData.length > 0;
  const totalRejected = rejectedMilkData.reduce(
    (sum, item) =>
      sum +
      (item.antibiotics_hormones || 0) +
      (item.adulterations_preservatives || 0),
    0,
  );

  // const antibioticsTotal = data.data.reduce(
  //   (sum, item) => sum + (item.antibiotics_hormones || 0),
  //   0,
  // );

  // const adulterationTotal = data.data.reduce(
  //   (sum, item) => sum + (item.adulterations_preservatives || 0),
  //   0,
  // );

  return (
    <div className="rejected-milk-viewer">
      <div className="rejected-milk-card">
        <div className="rejected-milk-body">
          <div className="rejected-milk-stamp">
            <img src={StampIcon} alt="Rejected stamp" className="stamp-image" />
          </div>
          <div className="metrics-container">
            <div className="metric-card">
            <div className="metric-left">
                <span className="metric-label">Milk Rejected On</span>

                <label className="rejected-date-picker">
                  <input
                    ref={dateInputRef}
                    type="date"
                    value={selectedDate}
                    onChange={(event) => onDateChange(event.target.value)}
                    aria-label="Select rejected milk date"
                    max={maxDate}
                  />

                  <span>{formatDisplayDate(selectedDate)}</span>

                  <img
                    src={CalendarIcon}
                    alt="Open calendar"
                    onClick={() => {
                      dateInputRef.current?.showPicker?.();
                      dateInputRef.current?.focus();
                    }}
                    style={{ cursor: "pointer" }}
                  />
                </label>
              </div>
              <span className="metric-value">
                {isLoading
                  ? "Loading..."
                  : hasRejectedMilkData
                    ? `${totalRejected.toFixed(0)} L`
                    : 
                    <span style={{
                      color:"#CAC6CA"
                    }}>No data</span>}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RejectedMilkViewer;
